$(function () {

  $(window).on("load resize", function () {
    heroPosterVideo();

    var win = $(window).width(),
      nav = $(".js-gta-navigation");
    if (win >= 768) {
      var headerHeight = $("header").height();
      $(window).scroll(function () {
        $(window).scrollTop() > headerHeight ? nav.addClass("is-fixed") : nav.removeClass("is-fixed");
      });
    }
  });

  // 現在ページ表示
  $('.js-gta-navigation-content a').each(function () {
    var href = $(this).attr('href');
    if (location.href.match(href)) {
      $(this).addClass('active');
      !$(this).parents(".site-mainarticle").hasClass("gta") ? $(".js-gta-navigation-content li:first-child a").removeClass('active') : "";
    } else {
      $(this).removeClass('active');
    }
  });

  function heroPosterVideo() {
    var $video = $(".js-gta-video");
    var $video_data_poster;
    if ($(window).width() > 1024) {
      $video_data_poster = $video.attr("data-poster");
    } else if ($(window).width() > 768 && $(window).width() < 1025) {
      $video_data_poster = $video.attr("data-poster-tablet-l");
    } else if ($(window).width() > 640 && $(window).width() < 769) {
      $video_data_poster = $video.attr("data-poster-tablet-p");
    } else if ($(window).width() < 641) {
      $video_data_poster = $video.attr("data-poster-mobile");
    }
    $video.attr("poster", $video_data_poster);
  }

  $('.js-gta-gallery').slick({
    dots: true,
    infinite: false,
    centerMode: true,
    centerPadding: '6vw',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
        }
      }
    ],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });
  $('.js-gta-movie').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });

  //experience
  var slide = $(".js-slide"),
  slideNav = $(".js-slide-navigation");

  slide.slick({
    dots: false,
    infinite: false,
    speed: 600,
    asNavFor: ".js-slide-navigation",
    responsive: [{
      breakpoint: 9999,
      settings: {
        arrows: false
      }
    }, {
      breakpoint: 768,
      settings: {
        arrows: true
      }
    }],
    prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>',
    nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14.89" height="27.78" viewBox="0 0 14.89 27.78"><path d="M0,1,1,0l13.9,13.89L1,27.78l-1-1,12.9-12.9L0,1Z"/></svg></div>'
  });

  slideNav.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    // draggable: false,
    variableWidth: true
  });

  $(".slick-slide", slideNav).each(function (i) {
    var target = $(this).data("slick-index");
    $(this).click(function () {
      slide.slick("slickGoTo", target, false);
    });
  });

  slide.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $(".slick-slide li", slideNav).removeClass('active');
    $(".slick-current li", slideNav).addClass('active');
    $(".slick-track", slideNav).removeAttr("style");
  });

  // additional color
  $('.gta-color-liveries .u-product-prev-arrow span').text("TOP");
  $('.gta-color-liveries .u-product-next-arrow span').text("REAR");

  $(".js-bodyColorList li").each(function () {
    var bgImage = $(this).data("background");
    $(this).css({
      background: "url(" + bgImage + ") center center no-repeat",
      backgroundSize: "cover"
    });
  });

  // $(".js-colors li").each(function () {
  //   if ($(this).hasClass("red")) {
  //     var bgColor = $(this).css("background-color").replace(')', ', 0.5)').replace('rgb', 'rgba');
  //     $(this).css({boxShadow: bgColor+" 0px 0px 0px 2px"});
  //   }

  //   $(this).click(function () {
  //     var colorName = $(this).text(),
  //     bgColor = $(this).hasClass("white") ? "rgba(209,209,209,0.5)" : $(this).css("background-color").replace(')', ', 0.5)').replace('rgb', 'rgba');
  //     $(".js-colors-name").text(colorName);
  //     $(".js-colors li").removeAttr("style");
  //     $(this).css({boxShadow: bgColor+" 0px 0px 0px 2px"});
  //   });
  // });

});